"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.erfDocs = void 0;
var erfDocs = exports.erfDocs = {
  name: 'erf',
  category: 'Special',
  syntax: ['erf(x)'],
  description: 'Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x',
  examples: ['erf(0.2)', 'erf(-0.5)', 'erf(4)'],
  seealso: []
};